import { render, staticRenderFns } from "./Visualizar_Fichero.vue?vue&type=template&id=082d26dc&scoped=true"
import script from "./Visualizar_Fichero.vue?vue&type=script&lang=js"
export * from "./Visualizar_Fichero.vue?vue&type=script&lang=js"
import style0 from "./Visualizar_Fichero.vue?vue&type=style&index=0&id=082d26dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082d26dc",
  null
  
)

export default component.exports